<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
                            </v-card-title> -->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formTalla" :v-model="true" lazy-validation>
            <v-flex xs12 sm12 md12>
              <v-select
                v-model="talla.tipoProductoId"
                :items="tiposProducto"
                item-text="descripcion"
                item-value="tipoProductoId"
                label="Tipo de producto *"
                placeholder="Tipo de producto"
                single-line
                :rules="[
                  () => !!talla.tipoProductoId || 'El campo es requerido',
                ]"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Descripción talla de producto *"
                v-model="talla.descripcion"
                placeholder="Descripción talla del producto: CHICA, GRANDE, 15 1/2, 36, 42, XL"
                hint="Descripción talla del producto: CHICA, GRANDE, 15 1/2, 36, 42, XL"
                :rules="[() => !!talla.descripcion || 'El campo es requerido']"
                :counter="60"
                required
              ></v-text-field>
            </v-flex>
            <v-layout wrap class="container">
              <v-flex xs12 sm12 md12>
                <v-alert
                  :value="true"
                  color="warning"
                  icon="priority_high"
                  outline
                >
                  Especifica si al seleccionar la talla se agregará el producto
                  seleccionado por default en la venta y renta.
                </v-alert>
              </v-flex>
              <v-flex xs11 sm11 md11>
                <v-select
                  v-model="talla.catalogoRowIdAgregado"
                  :items="catalogoProductos"
                  :item-text="
                    (item) =>
                      `${item.descripcionProducto} -Venta: $ ${item.precioVenta} Renta: $ ${item.precioRenta}`
                  "
                  item-value="catalogoRowId"
                  label="Producto a agregar"
                  placeholder="Producto que se agregará si esta talla es seleccionada"
                  @keydown.esc="clearCatalogoProducto()"
                  single-line
                ></v-select>
              </v-flex>
              <v-flex xs1 sm1 md1 v-if="talla.catalogoRowIdAgregado">
                <v-btn color="error" @click="clearCatalogoProducto">X</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveTalla"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
      >
        Talla guardada con éxito
      </v-alert>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import tallaService from "@/services/tallaService";
import tipoProductoService from "@/services/tipoProductoService";
import catalogoProductoService from "@/services/catalogoProductoService";

export default {
  props: {
    talla: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      tiposProducto: [],
      catalogoProductos: [],
    };
  },
  mounted() {
    this.getTiposProducto();
    this.getCatalogoProductosTallaExtra();
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getTiposProducto() {
      let self = this;

      tipoProductoService
        .getAll()
        .then((result) => {
          self.tiposProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getCatalogoProductosTallaExtra() {
      let self = this;

      catalogoProductoService
        .getAll(60)
        .then((result) => {
          self.catalogoProductos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    saveTalla() {
      let self = this;

      if (self.$refs.formTalla.validate()) {
        self.operationStart();

        if (self.talla.tallaId === 0) {
          self.addTalla();
        } else {
          self.updateTalla();
        }
      }
    },
    addTalla() {
      let self = this;

      tallaService
        .add(self.talla)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onTallaAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateTalla() {
      let self = this;

      tallaService
        .update(self.talla)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onTallaUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    clearCatalogoProducto() {
      this.$nextTick(() => {
        this.talla.catalogoRowIdAgregado = null;
      });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.talla.tallaId = 0;
      self.talla.tipoProductoId = 0;
      self.talla.descripcion = "";
      self.$refs.formTalla.resetValidation();
    },
  },
};
</script>
